import React, { useState, useEffect, useContext, useRef } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Box, Button, TextField, Table, TableHead, TableBody, TableRow, TableCell, MenuItem, IconButton, InputAdornment, Checkbox, makeStyles, useMediaQuery, InputLabelProps, FormHelperText } from '@material-ui/core'
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { useSwipeable } from 'react-swipeable'
import md5 from 'blueimp-md5'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import SaveIcon from '@material-ui/icons/Save'
import CircleCheckedFilled from '@material-ui/icons/CheckCircle'
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked'
import { AuthContext } from '../../App.js'
import './index.css'
import Header from '../Header'
import ModalDeleteAlert from '../ModalDeleteAlert'
import ModalLogoutAlert from '../ModalLogoutAlert'
import Loading from '../LoadingComponent'
import Confirmation from '../ConfirmationComponent'
import COLORS from '../../colors'
import axios from 'axios'
import { getHostName } from '../../base.js'
import { ReactComponent as Arrow } from '../../assets/arrow.svg'
import { ReactComponent as Search } from '../../assets/search.svg'

//STXYLING
const useStyles = makeStyles((theme) => ({
      input: {
            background: COLORS.gray,
            borderRadius: '2rem',
            margin: '1rem'
      },
      table: {
            width: '100%',
      },
      tableRow: {
            '&:hover': {
                  zIndex: '1000',
                  backgroundColor: COLORS.gray,
            }
      },
      checkbox: {
            padding: '1rem',
            width: '1rem',
            margin: '0rem',
      },
      arrow: {
            padding: '1rem',
            paddingTop: '1.4rem',
            margin: 0,
            width: '1rem',
            cursor: 'pointer'
      },
      nameHead: {
            paddingTop: '0.6rem',
            paddingBottom: '0.6rem',
            padingRight: 0,
            paddingLeft: 0,
            margin: 0,
            color: COLORS.darkGray,
            fontWeight: '500',
      },
      rankHead: {
            padding: 0,
            margin: 0,
            color: COLORS.darkGray,
            fontWeight: '500',
      },
      nameBody: {
            padding: 0,
            fontWeight: '700',
            cursor: 'pointer'
      },
      rankBody: {
            padding: 0,
            color: '#C8C8C8',
            fontWeight: '700',
            cursor: 'pointer'
      },
      root: {
            color: COLORS.blue,
            "&$checked": {
                  color: '#2F2F5B'
            }
      },
      btnNew: {
            position: 'fixed',
            top: '85vh',
            display: 'flex',
            width: '90%',
            justifyContent: 'center',
            background: COLORS.blue,
            color: '#fff',
            fontSize: '1rem',
            fontWeight: '500',
            zIndex: '1',
            "&:hover": {
                  backgroundColor: COLORS.blue
            }
      },
      btnNewCashier: {
            display: 'flex',
            justifyContent: 'center',
            background: COLORS.blue,
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 'bold',
            "&:hover": {
                  backgroundColor: COLORS.blue
            }
      },
      btnEditCashier: {
            display: 'flex',
            width: '90%',
            justifyContent: 'center',
            background: COLORS.blue,
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 'bold',
            "&:hover": {
                  backgroundColor: COLORS.blue
            }
      },
      btnCancle: {
            display: 'flex',
            justifyContent: 'center',
            background: '#fff',
            color: COLORS.blue,
            border: '2px solid #2F2F5B',
            fontSize: '1rem',
            fontWeight: 'bold',
            marginTop: '0.6rem',
            marginBottom: '0.6rem',
            "&:hover": {
                  backgroundColor: 'fff'
            }
      },
      inputForm: {
            display: 'flex',
            justifyContent: 'center',
            margin: '1rem',
      },
      inputNewcategory: {
            display: 'flex',
            justifyContent: 'right',
            marginLeft: '5rem',
            marginRight: '1rem'
      }
}));

const AdminCashiers = ({ editedCashier, userId, cid, token, cashierList }) => {
      const matches = useMediaQuery('(min-width:600px)')
      const [isOpen, setIsOpen] = useState(false)
      const [cashiers, setCashiers] = useState([])
      const [searchString, setSearchString] = useState('')
      const [searchArr, setSearchArr] = useState([])
      const [isLoading, setIsLoading] = useState(true)
      const [isChecked, setIsChecked] = useState(false)
      const [checkedDict, setCheckedDict] = useState({})
      const [popup, setPopup] = useState(false)
      const [pinWarn, setPinWarn] = useState(false)
      const [emailWarn, setEmailWarn] = useState(false)
      const classes = useStyles()
      const navigate = useNavigate()
      const params = useParams()
      const { editCashier, resetEditedCashier, setCashierList, setPageNumber, setPrevPage, signOut, resetPN } = useContext(AuthContext)
      const [firstName, setFirstName] = useState('')
      const [lastName, setLastName] = useState('')
      const [code, setCode] = useState('')
      const [rank, setRank] = useState('')
      const [pin, setPin] = useState('')
      const [email, setEmail] = useState('')
      const [userName, setUserName] = useState('')
      
      const [isDisabled, setIsDisabled] = useState(true)
      const [isConfirm, setIsConfirm] = useState(false)
      const [keypad, setKeypad] = useState(false)
      const [inputName, setInputName] = useState(null);
      const [inputLastname, setInputLastname] = useState(null)
      const [inputCode, setInputCode] = useState(null)
      const [inputRank, setInputRank] = useState(null)
      const [inputPin, setInputPin] = useState(null)
      const [inputEmail, setInputEmail] = useState(null)
      const [inputUsername, setInputUsername] = useState(null)
      const [inputPassword, setInputPassword] = useState(null)
      const [popupIsModalLogout, setPopupIsModalLogout] = useState(false)
      const [width, setWidth] = useState(window.innerWidth)
      const [height, setHeight] = useState(window.innerHeight)
      //username suggestions and availabioilty 
      const [isUsernameValid, setIsUsernameValid] = useState(true);
      const [suggestions, setSuggestions] = useState([]);
      //END username suggestions and availabioilty  

      //Password Strength and password strength related stuff
      const [isPasswordStrong, setIsPasswordStrong] = useState(true);
      const [originalPassword, setOriginalPassword] = useState('');  // Keeping original pasword when editing user
      const [hasPasswordChanged, setHasPasswordChanged] = useState(false);


      const [password, setPassword] = useState('')

      //RUNS when component mounts - cross browser stuff presumably
      useEffect(() => {
            function hideKeypad() {
                  setWidth(window.innerWidth)
                  setHeight(window.innerHeight)
            }
            window.addEventListener('resize', hideKeypad, false)
            return () => window.removeEventListener('resize', hideKeypad, false)
      }, [])
      // setup ref for your usage
      const myRef = useRef();
      const handlers = useSwipeable({ onSwipedLeft: () => handleSwipeLeft() })

      const handleSwipeLeft = () => {
            setPageNumber(null)
            navigate(`/kekspos/${params.tid}`)
      }

      const refPassthrough = (el) => {
            // call useSwipeable ref prop with el
            handlers.ref(el)
            // set myRef el so you can access it yourself
            myRef.current = el
      }

      useEffect(() => {
            if (height > 500 && inputName !== null) {
                  inputName.blur()
            }
            if (height > 500 && inputLastname !== null) {
                  inputLastname.blur()
            }
            if (height > 500 && inputCode !== null) {
                  inputCode.blur()
            }
            if (height > 500 && inputRank !== null) {
                  inputRank.blur()
            }
            if (height > 500 && inputPin !== null) {
                  inputPin.blur()
            }
            if (height > 500 && inputEmail !== null) {
                  inputEmail.blur()
            }
            if (height > 500 && inputUsername !== null) {
                  inputUsername.blur()
            }
            if (height > 500 && inputPassword !== null) {
                  inputPassword.blur()
            }
      }, [height])

      const handleInputScroll = () => {
            setKeypad(true)
            document.querySelector(".modal-form").scrollTo({ left: 0, top: document.querySelector(".modal-form").scrollHeight, behavior: "smooth" })
      }

      const handleFirstName = (e) => {
            e.persist()
            if (e.target.value.length < 20) {
                  setFirstName(e.target.value)
            }
      }
      const handleLastName = (e) => {
            e.persist()
            if (e.target.value.length < 20) {
                  setLastName(e.target.value)
            }
      }
      const handleCode = (e) => {
            if (code < 1000000000) {
                  if (e.key >= 0 && e.key <= 9) {
                        if (code === '') {
                              setCode(parseInt(e.key))
                        } else {
                              setCode(code * 10 + parseInt(e.key))
                        }
                  } else if (e.key === 'Backspace') {
                        var usrCode = Math.floor(code / 10)
                        if (usrCode === 0) {
                              setCode('')
                        } else {
                              setCode(usrCode)
                        }
                  }
            } else if (e.key === 'Backspace') {
                  setCode(Math.floor(code / 10))
            }
      }
      const handleRank = (e) => {
            e.persist()
            setRank(e.target.value)
      }
      const handlePin = (e) => {
            if (pin < 10000000000) {
                  if (e.key >= 0 && e.key <= 9) {
                        if (pin === '') {
                              setPin(parseInt(e.key))
                        } else {
                              setPin(pin * 10 + parseInt(e.key))
                        }
                  } else if (e.key === 'Backspace') {
                        var usrPin = Math.floor(pin / 10)
                        if (usrPin === 0) {
                              setPin('')
                        } else {
                              setPin(usrPin)
                        }
                  }
            } else if (e.key === 'Backspace') {
                  setPin(Math.floor(pin / 10))
            }
      }
      const handleEmail = (e) => {
            e.persist()
            if (e.target.value.length < 30) {
                  setEmail(e.target.value)
            }
      }
      const validateEmail = (email) => {
            if (email === '' || email === undefined) return true
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(email.toLowerCase())
      }
      const handleUserName = (e) => {
            e.persist()
            if (e.target.value.length < 31) {
                  setUserName(e.target.value)
            }
      }
      const handlePassword = (e) => {
            e.persist()
            if (e.target.value.length < 31) {
                  // setPassword(e.target.value)
                  const newPassword = e.target.value;
                  setPassword(newPassword);
                  setIsPasswordStrong(isPasswordStrongFunc(newPassword));
                  if (newPassword.length === 0) {
                        setIsPasswordStrong(true)
                  }
            }

           if (e.target.value === '') {
                  setOriginalPassword(editedCashier.password);
            } else {
                  setOriginalPassword(e.target.value);
            }            
          
      }

      const isPasswordStrongFunc = (password) => {
            const minLength = 8;
            const hasUppercase = /[A-Z]/.test(password);
            const hasLowercase = /[a-z]/.test(password);
            const hasNumber = /[0-9]/.test(password);
            const hasSpecialChar = /[^A-Za-z0-9]/.test(password);

            return password.length >= minLength && hasUppercase && hasLowercase && hasNumber && hasSpecialChar;
      };



      //give me all your hash
      const generateHash = async (passwd) => {
            return await md5(passwd)
      }
      //RUNS when component mounts, sets page number of previposu page, breadcrumb  not to get lost like in ferytale :)
      useEffect(() => {
            setPrevPage({ prevPageNum: 9 })
            window.onpopstate = function (e) {
                  e.preventDefault()
                  setTimeout(() => {
                        navigate(`/kekspos/${params.tid}`);
                  }, 0)

                  window.onpopstate = null
                  //return "Data will be lost if you leave the page, are you sure?";

            }
      }, [])

      const onBackButtonEvent = (e) => {
            e.preventDefault()

            //signOut(cid)
            navigate(`/kekspos/${params.tid}`)
            resetPN()
      }
      //HANDLE reload, runs when component mounts
      useEffect(() => {
            const handleReload = async (e) => {
                  e.preventDefault()
                  signOut(cid)
                  setTimeout(() => window.location.assign(`/kekspos`, 0)); //setTimeout(() => window.location.assign(`/kekspos/?cid=${cid}`, 0));
                  window.removeEventListener('beforeunload', handleReload)
                  return false
            }

            window.addEventListener("beforeunload", handleReload)

            return () => {
                  window.removeEventListener('beforeunload', handleReload)
            }

      }, [])
      //GETTING cashiers call to API
      const getData = async () => {
            const config = {
                  headers: {
                        'X-Session-Token': token
                  }
            };
            return await axios.get(getHostName() + '/cashier?tid=' + params.tid, config).then(response => {
                  return response.data
            }).catch(error => {
                  console.log("Error happend while requesting the data...")
            })
      }

      //THIS RUNS when component mounts only, most likely
      useEffect(() => {
            if (cashierList.length === 0) {
                  setIsLoading(true)
                  getData().then(apiData => {
                        if (apiData.resultCode === 0) {
                              console.log("apidata",apiData);
                              setCashiers(apiData.result)
                              setCashierList(apiData.result)
                              setTimeout(() => setIsLoading(false), 1000)
                        } else {
                              setTimeout(() => setIsLoading(false), 1000)
                              setPopupIsModalLogout(true)
                        }
                  })
            } else {
                  setCashiers(cashierList)
                  setTimeout(() => setIsLoading(false), 1000)
            }
      }, [])

      //RUNS whenever cashier changes
      useEffect(() => {
            const loadCheckBox = () => {
                  var arr = {}
                  for (let num in cashiers) {
                  
                        arr[cashiers[num].id] = false
                  }
                  setCheckedDict(arr)
            }
            loadCheckBox()
      }, [cashiers])
    
      useEffect(() => {
            if (editedCashier === null) {
                  if (firstName !== '' && lastName !== '' && code !== '' && rank !== '' && userName !== '' && password !== '' && isPasswordStrong !== false) {
                        setIsDisabled(false)
                  } else {
                        setIsDisabled(true)
                  }
            } else if (editedCashier !== null) {


                  if (firstName !== editedCashier.firstName || lastName !== editedCashier.lastName
                        || code !== editedCashier.code || rank !== editedCashier.rank
                        || pin !== editedCashier.pin || email !== editedCashier.email
                        || userName !== editedCashier.username || originalPassword !== editedCashier.password) {
                        if (firstName !== '' && lastName !== '' && code !== '' && rank !== '' && userName !== '' && originalPassword !== '' && isPasswordStrong !== false) {
                              setIsDisabled(false)
                        } else {
                              setIsDisabled(true)
                        }
                  } else {
                        setIsDisabled(true)
                         
                  }
            }
      }, [firstName, lastName, code, rank, pin, email, userName, password ])

      const handleEdit = (item) => {
            setFirstName(item.firstName)
            setLastName(item.lastName)
            setCode(item.code)
            setRank(item.rank)
            setPin(item.pin)
            setEmail(item.email)
            setUserName(item.username)
            setOriginalPassword(item.password)
            setPassword('')
            editCashier(item)
            setIsOpen(true)
      }

      const editData = async (firstName, lastName, codeId, userRank, userPin, userEmail, usrname, passwd) => {
            const config = {
                  headers: {
                        'X-Session-Token': token
                  }
            };
            return await axios.put(getHostName() + '/cashier',
                  {
                        id: editedCashier.id,
                        tid: params.tid,
                        hasusernamechanged: editedCashier.username !== usrname? true:false ,
                        username: usrname,
                        password: passwd,
                        code: codeId,
                        firstName: firstName,
                        lastName: lastName,
                        pin: userPin,
                        email: userEmail,
                        rank: userRank,
                        phone: '123456789',
                        attempts: 0
                  }, config).then(response => {
                        return response.data
                  }).catch(error => {
                        signOut(cid)
                        console.log("Error happend while requesting the data...")
                  })
      }
      // call API for edit casheir
      const handleSubmitEditCashier = async (event) => {
            event.preventDefault()
            if ((pin !== '' && (Math.floor(pin / 10000000000) < 1)) || (!validateEmail(email))) {
                  if (pin !== '' && (Math.floor(pin / 10000000000) < 1)) {
                        if (!pinWarn) {
                              setPinWarn(true)
                              setTimeout(function () { setPinWarn(false) }, 2000)
                        }
                  }
                  if (!validateEmail(email)) {
                        if (!emailWarn) {
                              setEmailWarn(true)
                              setTimeout(function () { setEmailWarn(false) }, 2000)
                        }
                  }
                  return
            }
            setIsLoading(true)
            if (originalPassword !== editedCashier.password) {
                  generateHash(originalPassword).then(hashPasswd => {
                        editData(firstName, lastName, code, rank, pin, email, userName, hashPasswd).then(apiData => {
                              if (apiData.resultCode === 0) {
                                    setFirstName('')
                                    setLastName('')
                                    setCode('')
                                    setRank('')
                                    setPin('')
                                    setEmail('')
                                    setUserName('')
                                    setPassword('')
                                    setOriginalPassword('')
                                    var arr = cashiers.filter(item => item.id !== editedCashier.id)
                                    var cashierList = [...arr, apiData.result]
                                    cashierList.sort((a, b) => (a.username > b.username ? 1 : -1))
                                    setCashiers(cashierList)
                                    setCashierList(cashierList)
                                    resetEditedCashier()
                                    setIsDisabled(true)
                                    setIsOpen(false)
                                    setIsLoading(false)
                              } else if (apiData.resultCode === 1) {
                                    setSuggestions(apiData.suggestions);
                                    setIsDisabled(false) //disables  "DODAJ"  button control
                                    setIsLoading(false) // sets KEKS animation to entertain user
                                    setIsOpen(true)  //  disable or enables admin users window
                                    //setIsConfirm(true)  //confirmation window about user being added
                                    setIsUsernameValid(false);
                              } else {
                                    setTimeout(() => setIsLoading(false), 1000)
                                    setPopupIsModalLogout(true)
                              }
                        })
                  })
            } else {
                 // setPassword(originalPassword);
                  editData(firstName, lastName, code, rank, pin, email, userName, originalPassword).then(apiData => {
                        if (apiData.resultCode === 0) {
                              setFirstName('')
                              setLastName('')
                              setCode('')
                              setRank('')
                              setPin('')
                              setEmail('')
                              setUserName('')
                              setPassword('')
                              setOriginalPassword('')
                              var arr = cashiers.filter(item => item.id !== editedCashier.id)
                              var cashierList = [...arr, apiData.result]
                              cashierList.sort((a, b) => (a.username > b.username ? 1 : -1))
                              setCashiers(cashierList)
                              setCashierList(cashierList)
                              resetEditedCashier()
                              setIsDisabled(true)
                              setIsOpen(false)
                              setIsLoading(false)
                              setSuggestions([])
                        } else if (apiData.resultCode === 1) {
                              setSuggestions(apiData.suggestions);
                              setIsDisabled(false) //disables  "DODAJ"  button control
                              setIsLoading(false) // sets KEKS animation to entertain user
                              setIsOpen(true)  //  disable or enables admin users window
                              //setIsConfirm(true)  //confirmation window about user being added
                              setIsUsernameValid(false);
                        } else {
                              setTimeout(() => setIsLoading(false), 1000)
                              setPopupIsModalLogout(true)
                        }
                  })
            }
      }
      // call API for creating new casheir
      const handleSubmitNewCashier = async (event) => {
            event.preventDefault()
            if (pin !== '' && (Math.floor(pin / 10000000000) < 1) || !validateEmail(email)) {
                  if (pin !== '' && (Math.floor(pin / 10000000000) < 1)) {
                        if (!pinWarn) {
                              setPinWarn(true)
                              setTimeout(function () { setPinWarn(false) }, 2000)
                        }
                  }
                  if (!validateEmail(email)) {
                        if (!emailWarn) {
                              setEmailWarn(true)
                              setTimeout(function () { setEmailWarn(false) }, 2000)
                        }
                  }
                  return
            }
            setIsLoading(true)
            generateHash(password).then(hashPassword => {
                  newData(firstName, lastName, code, rank, pin, email, userName, hashPassword).then(apiData => {
                        if (apiData.resultCode === 0) {
                              setFirstName('')
                              setLastName('')
                              setCode('')
                              setRank('')
                              setPin('')
                              setEmail('')
                              setUserName('')
                              setPassword('')
                              var cashierList = [...cashiers, apiData.result]
                              cashierList.sort((a, b) => (a.username > b.username ? 1 : -1))
                              setCashiers(cashierList)
                              setCashierList(cashierList)
                              setIsDisabled(true)
                              setIsLoading(false)
                              setIsOpen(false)
                              setIsConfirm(true)
                        } else if (apiData.resultCode === 1) {
                              setSuggestions(apiData.suggestions);
                              setIsDisabled(false) //disables  "DODAJ"  button control
                              setIsLoading(false) // sets KEKS animation to entertain user
                              setIsOpen(true)  //  disable or enables admin users window
                              //setIsConfirm(true)  //confirmation window about user being added
                              setIsUsernameValid(false);

                        } else {
                              setTimeout(() => setIsLoading(false), 1000)
                              setPopupIsModalLogout(true)
                        }
                  }).catch(error => {
                        console.log("Can't create new cashier, error", error)
                  })
            })
      }


      const newData = async (firstName, lastName, userCode, userRank, userPin, userEmail, usrname, passwd) => {
            const config = {
                  headers: {
                        'X-Session-Token': token
                  }
            };
            return await axios.post(getHostName() + '/cashier',
                  {
                        cid,
                        tid: params.tid,
                        username: usrname,
                        password: passwd,
                        firstName: firstName,
                        lastName: lastName,
                        code: userCode,
                        pin: userPin,
                        email: userEmail,
                        rank: userRank,
                        phone: '123456789',
                        attempts: 0  
                  }, config).then(response => {
                        return response.data
                  }).catch(error => {
                        signOut(cid)
                        console.log("Error happend while requesting the data...")
                  })
      }
      const removeData = async (items) => {
            return await axios.delete(getHostName() + '/cashier', { data: { ids: items, tid: params.tid }, headers: { 'X-Session-Token': token } })
                  .then(response => {

                  return response.data
            }).catch(error => {
                  signOut(cid)
                  console.log("Error happend while requesting the data...")
            })
      }

      const handleDeleteItems = () => {
            var checkedElements = {}
            var arr = cashiers
            var itemsToBeRemoved = []
            for (let id in checkedDict) {
                  if (checkedDict[id]) {
                        itemsToBeRemoved = [...itemsToBeRemoved, parseInt(id)]
                        arr = arr.filter(item => item.id !== parseInt(id))
                  } else {
                        checkedElements[id] = false
                  }
            }
            setIsLoading(true)
            removeData(itemsToBeRemoved).then(apiData => {
                  if (apiData.resultCode === 0) {
                        setCashiers(arr)
                        setCashierList(arr)
                        setCheckedDict(checkedElements)
                        setIsLoading(false)
                        setIsChecked(false)
                        setPopup(false)
                  }
                  else {
                        setPopup(false)
                        setTimeout(() => setIsLoading(false), 1000)
                        setPopupIsModalLogout(true)
                  }
            })
      }

      const showDeleteButton = () => {
            let sum = 0
            for (let ele in checkedDict) {
                  if (checkedDict[ele]) {
                        sum += 1
                        setIsChecked(true)
                        return
                  }
            }
            if (sum === 0 && isChecked) {
                  setIsChecked(false)
            }
      }

      const handleCheckboxChange = (event, id) => {
            var checkedEle = checkedDict
            checkedEle[id] = !checkedEle[id]
            setCheckedDict(checkedEle)
            showDeleteButton()
      }

      const handleSearch = (event) => {
            event.persist();
            setSearchString(event.target.value)
      }

      useEffect(() => {
            console.log(cashiers)
            setSearchArr(cashiers.filter(item => item.username.toLowerCase().includes(searchString.toLowerCase())))
      }, [searchString, cashiers])



      const handleClose = () => {
            setFirstName('')
            setLastName('')
            setCode('')
            setRank('')
            setPin('')
            setEmail('')
            setUserName('')
            setPassword('')
            if (editedCashier !== null) {
                  resetEditedCashier()
            }
            setIsUsernameValid(true)
            setSuggestions([])
            setIsPasswordStrong(true)
            setOriginalPassword('')
            setIsDisabled(true)
            setIsOpen(false)
      }

      const handleLogout = () => {
            setPopupIsModalLogout(false)
            setIsLoading(true)
            setTimeout(() => setIsLoading(false), 1000)
            resetPN()
            setTimeout(() => window.location.assign(`/kekspos`, 0))
      }

      if (!isLoading && !isConfirm) {
            return (
                  <div className="admin-cashier"  >
                        <ModalDeleteAlert popup={popup} pageNumber={9} onClose={() => setPopup(false)} onDelete={() => handleDeleteItems()} />
                        <ModalLogoutAlert popup={popupIsModalLogout} onClose={() => handleLogout()} />
                        {editedCashier === null ?
                              (<div className={isOpen ? "modal-open" : "modal-close"} style={{ height: height > 500 ? '100vh' : '85vh' }}>
                                    <Header pageNumber={13} onClose={() => handleClose()} />
                                    <form className="modal-form" noValidate autoComplete="off" onSubmit={(event) => handleSubmitNewCashier(event)}>
                                          <TextField label="Ime"
                                                variant="outlined"
                                                type="text"
                                                name="name"
                                                inputRef={(input) => { if (input != null) { setInputName(input) } }}
                                                className={classes.inputForm}
                                                onFocus={() => setKeypad(true)}
                                                onBlur={() => setKeypad(false)}
                                                value={firstName}
                                                onChange={(e) => handleFirstName(e)}
                                          />
                                          <TextField label="Prezime"
                                                variant="outlined"
                                                type="text"
                                                name="surname"
                                                inputRef={(input) => { if (input != null) { setInputLastname(input) } }}
                                                className={classes.inputForm}
                                                onFocus={() => setKeypad(true)}
                                                onBlur={() => setKeypad(false)}
                                                value={lastName}
                                                onChange={(e) => handleLastName(e)}
                                          />
                                          <TextField label="Korisnički broj"
                                                variant="outlined"
                                                type="number"
                                                name="code"
                                                inputRef={(input) => { if (input != null) { setInputCode(input) } }}
                                                className={classes.inputForm}
                                                onFocus={() => setKeypad(true)}
                                                onBlur={() => setKeypad(false)}
                                                value={code}
                                                onKeyDown={(e) => handleCode(e)}
                                          />
                                          <TextField label="Tip"
                                                variant="outlined"
                                                type="number"
                                                name="rank"

                                                className={classes.inputForm}
                                                onFocus={() => setKeypad(true)}
                                                onBlur={() => setKeypad(false)}
                                                select
                                                value={rank}
                                                onChange={(e) => handleRank(e)}
                                          >
                                                <MenuItem value="0">blagajnik</MenuItem>
                                                <MenuItem value="1">viši blagajnik</MenuItem>
                                                <MenuItem value="2">administrator</MenuItem>
                                          </TextField>
                                          <TextField label={!pinWarn ? "OIB (nije obavezan)" : "Neispravan oib!"}
                                                variant="outlined"
                                                type="number"
                                                name="pin"
                                                inputRef={(input) => { if (input != null) { setInputPin(input) } }}
                                                className={classes.inputForm}
                                                onFocus={() => handleInputScroll()}
                                                onBlur={() => setKeypad(false)}
                                                value={pin}
                                                onKeyDown={(e) => handlePin(e)}
                                                InputLabelProps={{
                                                      style: {
                                                            fontSize: "1rem",
                                                            color: !pinWarn ? 'secondary' : "red"
                                                      }
                                                }}
                                          />
                                          <TextField label={!emailWarn ? "Email adresa (nije obavezna)" : "Neispravan email!"}
                                                variant="outlined"
                                                type="text"
                                                name="email"
                                                inputRef={(input) => { if (input != null) { setInputEmail(input) } }}
                                                className={classes.inputForm}
                                                onFocus={() => handleInputScroll()}
                                                onBlur={() => setKeypad(false)}
                                                value={email}
                                                onChange={(e) => handleEmail(e)}

                                                InputLabelProps={{
                                                      style: {
                                                            fontSize: "1rem",
                                                            color: !emailWarn ? 'secondary' : "red"
                                                      }
                                                }}
                                          />
                                          <TextField label={isUsernameValid ? "Korisničko ime" : "Korisničko ime je zauzeto! Odaberite ponuđeno ili pokušajte ponovo."}

                                                variant="outlined"
                                                type="text"
                                                name="username"
                                                inputRef={(input) => { if (input != null) { setInputUsername(input) } }}
                                                className={classes.inputForm}
                                                onFocus={() => handleInputScroll()}
                                                onBlur={() => setKeypad(false)}
                                                value={userName}
                                                onChange={(e) => handleUserName(e)}
                                                InputLabelProps={{
                                                      style: {
                                                            fontSize: "1rem",
                                                            color: isUsernameValid ? "black" : "red"
                                                      }
                                                }}
                                          />
                                          {suggestions.length > 0 && (
                                                <Box sx={{ mt: 0, mr: 0, mb: 0, ml: 2 }}>
                                                      {suggestions.map((suggestion, index) => (
                                                            <Link
                                                                  component="button"
                                                                  underline="none"
                                                                  style={{ textDecoration: 'none', paddingleft: 10, paddingRight: 5, marginLeft: 10 }}

                                                                  key={index}

                                                                  onClick={() => {
                                                                        setUserName(suggestion.suggestion);
                                                                        setIsUsernameValid(true);
                                                                        setSuggestions([]); //removes username suggestion from display
                                                                  }}
                                                            >
                                                                  {suggestion.suggestion}
                                                            </Link>
                                                      ))}
                                                </Box>
                                          )}
                                          <TextField label={(isPasswordStrong) ? "Lozinka" : "Lozinka koju ste unijeli nije dovoljno jaka"}
                                                variant="outlined"
                                                type="password"
                                                name="password"
                                                helperText="Molimo vas da koristite kombinaciju velikih i malih slova, brojeva i posebnih znakova kako biste povećali sigurnost vaše lozinke."
                                                inputRef={(input) => { if (input != null) { setInputPassword(input) } }}
                                                className={classes.inputForm}
                                                onFocus={() => handleInputScroll()}
                                                onBlur={() => setKeypad(false)}
                                                value={password}
                                                InputLabelProps={{
                                                      style: {
                                                            fontSize: "1rem",
                                                            color: (isPasswordStrong) ? "black" : "red"
                                                      }
                                                }}
                                                onChange={(e) => {
                                                      handlePassword(e)

                                                }}
                                          />
                                          {(!keypad || !isMobile) ? <div className="cashier-btn">
                                                <Button size="large"
                                                      variant="contained"
                                                      type="submit"
                                                      disabled={isDisabled}
                                                      className={classes.btnNewCashier}
                                                      style={{ width: !isMobile ? '25rem' : '90%' }}
                                                >DODAJ</Button>
                                          </div> : null}
                                    </form>
                                    {(!keypad || !isMobile) ? <div className="cashier-btn">
                                          <Button size="large"
                                                variant="contained"
                                                className={classes.btnCancle}
                                                style={{ width: !isMobile ? '25rem' : '90%' }}
                                                onClick={() => handleClose()}
                                          >ODUSTANI</Button>
                                    </div> : null}

                              </div>
                              ) : ( //EDIT CAHSIER part
                                    <div className={isOpen ? "modal-open" : "modal-close"} style={{ height: height > 500 ? '100vh' : '85vh' }}>
                                          <Header pageNumber={14} onClose={() => handleClose()} />
                                          <form className="modal-form" noValidate autoComplete="off" onSubmit={(event) => handleSubmitEditCashier(event)}>
                                                <TextField label="Ime"
                                                      variant="outlined"
                                                      type="text"
                                                      name="name"
                                                      inputRef={(input) => { if (input != null) { setInputName(input) } }}
                                                      className={classes.inputForm}
                                                      onFocus={() => setKeypad(true)}
                                                      onBlur={() => setKeypad(false)}
                                                      value={firstName}
                                                      onChange={(e) => handleFirstName(e)}
                                                />
                                                <TextField label="Prezime"
                                                      variant="outlined"
                                                      type="text"
                                                      name="surname"
                                                      inputRef={(input) => { if (input != null) { setInputLastname(input) } }}
                                                      className={classes.inputForm}
                                                      onFocus={() => setKeypad(true)}
                                                      onBlur={() => setKeypad(false)}
                                                      value={lastName}
                                                      onChange={(e) => handleLastName(e)}
                                                />

                                                <TextField label="Korisnički broj"
                                                      variant="outlined"
                                                      type="number"
                                                      name="code"
                                                      inputRef={(input) => { if (input != null) { setInputCode(input) } }}
                                                      className={classes.inputForm}
                                                      onFocus={() => setKeypad(true)}
                                                      onBlur={() => setKeypad(false)}
                                                      value={code}
                                                      onKeyDown={(e) => handleCode(e)}
                                                />
                                                <TextField label="Tip"
                                                      variant="outlined"
                                                      type="number"
                                                      name="rank"

                                                      className={classes.inputForm}
                                                      onFocus={() => setKeypad(true)}
                                                      onBlur={() => setKeypad(false)}
                                                      select
                                                      value={rank}
                                                      onChange={(e) => handleRank(e)}
                                                >
                                                      <MenuItem value="0">blagajnik</MenuItem>
                                                      <MenuItem value="1">viši blagajnik</MenuItem>
                                                      <MenuItem value="2">administrator</MenuItem>
                                                </TextField>
                                                <TextField label={!pinWarn ? "OIB (nije obavezan)" : "Neispravan oib!"}
                                                      variant="outlined"
                                                      type="number"
                                                      name="pin"
                                                      inputRef={(input) => { if (input != null) { setInputPin(input) } }}
                                                      className={classes.inputForm}
                                                      onFocus={() => setKeypad(true)}
                                                      onBlur={() => setKeypad(false)}
                                                      value={pin}
                                                      onKeyDown={(e) => handlePin(e)}
                                                      InputLabelProps={{
                                                            style: {
                                                                  fontSize: "1rem",
                                                                  color: !pinWarn ? 'secondary' : "red"
                                                            }
                                                      }}
                                                />
                                                <TextField label={!emailWarn ? "Email adresa (nije obavezna)" : "Neispravan email!"}
                                                      variant="outlined"
                                                      type="text"
                                                      name="email"
                                                      inputRef={(input) => { if (input != null) { setInputEmail(input) } }}
                                                      className={classes.inputForm}
                                                      onFocus={() => setKeypad(true)}
                                                      onBlur={() => setKeypad(false)}
                                                      value={email}
                                                      onChange={(e) => handleEmail(e)}
                                                      InputLabelProps={{
                                                            style: {
                                                                  fontSize: "1rem",
                                                                  color: !emailWarn ? 'secondary' : "red"
                                                            }
                                                      }}
                                                />
                                                <TextField label={isUsernameValid ? "Korisničko ime" : "Korisničko ime je zauzeto! Odaberite ponuđeno ili pokušajte ponovo."}

                                                      variant="outlined"
                                                      type="text"
                                                      name="username"
                                                      inputRef={(input) => { if (input != null) { setInputUsername(input) } }}
                                                      className={classes.inputForm}
                                                      onFocus={() => handleInputScroll()}
                                                      onBlur={() => setKeypad(false)}
                                                      value={userName}
                                                      onChange={(e) => handleUserName(e)}
                                                      InputLabelProps={{
                                                            style: {
                                                                  fontSize: "1rem",
                                                                  color: isUsernameValid ? "black" : "red"
                                                            }
                                                      }}
                                                />
                                                {suggestions.length > 0 && (
                                                      <Box sx={{ mt: 0, mr: 0, mb: 0, ml: 2 }}>
                                                            {suggestions.map((suggestion, index) => (
                                                                  <Link
                                                                        component="button"
                                                                        underline="none"
                                                                        style={{ textDecoration: 'none', paddingleft: 10, paddingRight: 5, marginLeft: 10 }}

                                                                        key={index}

                                                                        onClick={() => {
                                                                              setUserName(suggestion.suggestion);
                                                                              setIsUsernameValid(true);
                                                                              setSuggestions([]); //removes username suggestion from display
                                                                        }}
                                                                  >
                                                                        {suggestion.suggestion}
                                                                  </Link>
                                                            ))}
                                                      </Box>
                                                )}
                                                <TextField label={(isPasswordStrong) ? "Lozinka" : "Lozinka koju ste unijeli nije dovoljno jaka"}
                                                      variant="outlined"
                                                      type="password"
                                                      name="password"
                                                      helperText="Molimo vas da koristite kombinaciju velikih i malih slova, brojeva i posebnih znakova kako biste povećali sigurnost vaše lozinke."
                                                      inputRef={(input) => { if (input != null) { setInputPassword(input) } }}
                                                      className={classes.inputForm}
                                                      onFocus={() => handleInputScroll()}
                                                      onBlur={() => setKeypad(false)}
                                                      value={password}
                                                      InputLabelProps={{
                                                            style: {
                                                                  fontSize: "1rem",
                                                                  color: (isPasswordStrong) ? "black" : "red"
                                                            }
                                                      }}
                                                      onChange={(e) => {
                                                            handlePassword(e)

                                                      }}
                                                />
                                                {(!keypad || !isMobile) ? <div className="cashier-btn">
                                                      <Button size="large"
                                                            variant="contained"
                                                            type="submit"
                                                            disabled={isDisabled}
                                                            className={classes.btnEditCashier}
                                                            style={{ width: !isMobile ? '25rem' : '90%' }}
                                                      >UREDI DETALJE</Button>
                                                </div> : null}
                                          </form>
                                          {(!keypad || !isMobile) ? <div className="cashier-btn">
                                                <Button size="large"
                                                      variant="contained"
                                                      className={classes.btnCancle}
                                                      style={{ width: !isMobile ? '25rem' : '90%' }}
                                                      onClick={() => handleClose()}
                                                >ODUSTANI</Button>
                                          </div> : null}
                                    </div>
                              )}


                        <div className="admin-cashiers" style={{ zIndex: isOpen ? '0' : '1' }} {...handlers} ref={refPassthrough}>
                              <Header pageNumber={9} />
                              <div className="admin-cashiers-main">
                                    <div className="input-search">
                                          <TextField variant="outlined"
                                                style={{ width: !isMobile ? '35rem' : '100%' }}
                                                InputProps={{
                                                      className: classes.input,
                                                      startAdornment: (
                                                            <InputAdornment position="start">
                                                                  <IconButton>
                                                                        <Search />
                                                                  </IconButton>
                                                            </InputAdornment>
                                                      )
                                                }}
                                                onFocus={() => setKeypad(true)}
                                                onBlur={() => setKeypad(false)}
                                                value={searchString}
                                                onChange={(event) => handleSearch(event)}
                                          />
                                    </div>
                                    <div className="admin-cashiers-body">
                                          <div className="admin-cashiers-table" style={{ height: isMobile ? '63vh' : '70vh' }}>
                                                <Table stickyHeader className={classes.table} aria-label="sticky table" size="small">
                                                      <TableHead style={{ zIndex: isOpen ? '-1' : '1' }}>
                                                            <TableRow>
                                                                  <TableCell style={{ padding: 0, margin: 0, width: !isMobile ? '10%' : '3%' }}
                                                                        component="td"
                                                                        scope="row"
                                                                        align="right"
                                                                  />
                                                                  <TableCell className={classes.nameHead}
                                                                        style={{ width: !isMobile ? '40%' : '60%' }}
                                                                        component="td"
                                                                        scope="row"
                                                                  >Korisnici</TableCell>
                                                                  <TableCell className={classes.rankHead}
                                                                        style={{ width: !isMobile ? '20%' : '30%' }}
                                                                        component="td"
                                                                        scope="row"
                                                                        align="right"
                                                                  >Tip</TableCell>
                                                                  <TableCell style={{
                                                                        padding: 0, margin: 0,
                                                                        width: !isMobile ? '10%' : '3%'
                                                                  }}
                                                                        component="td"
                                                                        scope="row"
                                                                  />
                                                            </TableRow>
                                                      </TableHead>
                                                      {cashiers.length !== 0 ?
                                                            <TableBody>
                                                                  {searchArr.length === 0 ? (
                                                                        cashiers.map((item, id) =>
                                                                              <TableRow key={id} className={classes.tableRow}>
                                                                                    {(item.id !== parseInt(userId)) ?
                                                                                          <TableCell className={classes.checkbox}
                                                                                                component="td"
                                                                                                scope="row"
                                                                                                align="right">
                                                                                                <Checkbox key={item.id}
                                                                                                      value={checkedDict[item.id]}
                                                                                                      style={{ padding: 0, margin: 0, cursor: 'pointer' }}
                                                                                                      icon={<CircleUnchecked />}
                                                                                                      checkedIcon={<CircleCheckedFilled className={classes.root} />}
                                                                                                      onChange={event => handleCheckboxChange(event, item.id)}
                                                                                                />
                                                                                          </TableCell> : <TableCell className={classes.checkbox}
                                                                                                component="td"
                                                                                                scope="row"
                                                                                                align="right"
                                                                                          >p.k.</TableCell>}
                                                                                    <TableCell className={classes.nameBody}
                                                                                          component="td"
                                                                                          scope="row"
                                                                                          align="left"
                                                                                          style={{ color: (item.id === parseInt(userId)) ? COLORS.green : COLORS.blue }}
                                                                                          onClick={() => handleEdit(item)}
                                                                                    >
                                                                                          {item.username}
                                                                                    </TableCell>
                                                                                    {item.rank === 0 &&
                                                                                          <TableCell className={classes.rankBody}
                                                                                                component="td"
                                                                                                scope="row"
                                                                                                align="right"
                                                                                                onClick={() => handleEdit(item)}
                                                                                          >blagajnik</TableCell>}
                                                                                    {item.rank === 1 &&
                                                                                          <TableCell className={classes.rankBody}
                                                                                                component="td"
                                                                                                scope="row"
                                                                                                align="right"
                                                                                                onClick={() => handleEdit(item)}
                                                                                          >viši blagajnik</TableCell>}
                                                                                    {item.rank === 2 &&
                                                                                          <TableCell className={classes.rankBody}
                                                                                                component="td"
                                                                                                scope="row"
                                                                                                align="right"
                                                                                                onClick={() => handleEdit(item)}
                                                                                          >administrator</TableCell>}
                                                                                    <TableCell className={classes.arrow}
                                                                                          component="td"
                                                                                          scope="row"
                                                                                          align="left"
                                                                                          onClick={() => handleEdit(item)}
                                                                                    >
                                                                                          <Arrow />
                                                                                    </TableCell>
                                                                              </TableRow>)
                                                                  ) : (
                                                                        searchArr.map((item, id) =>
                                                                              <TableRow key={id} className={classes.tableRow}>
                                                                                    {(item.id !== parseInt(userId)) ?
                                                                                          <TableCell className={classes.checkbox}
                                                                                                component="td"
                                                                                                scope="row"
                                                                                                align="right">
                                                                                                <Checkbox key={item.id}
                                                                                                      value={checkedDict[item.id]}
                                                                                                      style={{ padding: 0, margin: 0, cursor: 'pointer' }}
                                                                                                      icon={<CircleUnchecked />}
                                                                                                      checkedIcon={<CircleCheckedFilled className={classes.root} />}
                                                                                                      onChange={event => handleCheckboxChange(event, item.id)}
                                                                                                />
                                                                                          </TableCell> : <TableCell className={classes.checkbox}
                                                                                                component="td"
                                                                                                scope="row"
                                                                                                align="right"
                                                                                          >p.k.</TableCell>}
                                                                                    <TableCell className={classes.nameBody}
                                                                                          component="td"
                                                                                          scope="row"
                                                                                          align="left"
                                                                                          style={{ color: (item.id === parseInt(userId)) ? COLORS.green : COLORS.blue }}
                                                                                          onClick={() => handleEdit(item)}
                                                                                    >
                                                                                          {item.username}
                                                                                    </TableCell>
                                                                                    {item.rank === 0 &&
                                                                                          <TableCell className={classes.rankBody}
                                                                                                component="td"
                                                                                                scope="row"
                                                                                                align="right"
                                                                                                onClick={() => handleEdit(item)}
                                                                                          >blagajnik</TableCell>}
                                                                                    {item.rank === 1 &&
                                                                                          <TableCell className={classes.rankBody}
                                                                                                component="td"
                                                                                                scope="row"
                                                                                                align="right"
                                                                                                onClick={() => handleEdit(item)}
                                                                                          >viši blagajnik</TableCell>}
                                                                                    {item.rank === 2 &&
                                                                                          <TableCell className={classes.rankBody}
                                                                                                component="td"
                                                                                                scope="row"
                                                                                                align="right"
                                                                                                onClick={() => handleEdit(item)}
                                                                                          >administrator</TableCell>}
                                                                                    <TableCell className={classes.arrow}
                                                                                          component="td"
                                                                                          scope="row"
                                                                                          align="left"
                                                                                          onClick={() => handleEdit(item)}
                                                                                    ><Arrow /></TableCell>
                                                                              </TableRow>)
                                                                  )}
                                                            </TableBody> :
                                                            null}
                                                </Table>
                                          </div>
                                          {(!keypad || !isMobile) ?
                                                <div className="cashier-btn" style={{ zIndex: isOpen ? '0' : '1' }}>
                                                      {!isChecked ? <Button size="large"
                                                            variant="contained"
                                                            className={classes.btnNew}
                                                            onClick={() => setIsOpen(true)}
                                                            style={{ top: !matches ? '85vh' : '90vh', width: !isMobile ? '25rem' : '90%' }}
                                                      >DODAJ NOVOG KORISNIKA</Button> :
                                                            <Button size="large"
                                                                  variant="contained"
                                                                  className={classes.btnNew}
                                                                  onClick={() => setPopup(true)}
                                                                  style={{ top: !matches ? '85vh' : '90vh', width: !isMobile ? '25rem' : '90%' }}
                                                            >OBRIŠI OZNAČENE KORISNIKE</Button>}
                                                </div> : null}
                                    </div>
                              </div>
                        </div>
                  </div>
            )
      } else if (isLoading && !isConfirm) {
            return (
                  <Loading />
            )
      } else if (!isLoading && isConfirm) {
            return (
                  <Confirmation cid={cid}
                        processed={true}
                        pageNumber={9}
                        onBackToCashierList={() => setIsConfirm(false)} />
            )
      }
}

export default AdminCashiers
